<template>
    <div class="flag-selector-container">
        <transition name="fade-page">
        <div v-show="!drawer" class="main-content">
             <header class="header-section">
                <h1 class="main-title">破浪下半程</h1>
                <h1 class="main-title">🚀 奔赴更广阔的自由</h1>
                <div class="subtitle-wrapper">
                    <span class="subtitle-badge">精进</span>
                    <span class="subtitle-badge">拓界</span>
                    <span class="subtitle-badge">跃升</span>
                </div>
            </header>
            <!-- <div class="header">
            <h1 class="main-title">
                <span class="highlight-text">破浪下半程</span> 
            </h1>
            <p class="sub-title">（最多选择3个核心目标）</p>
            </div> -->

            <div class="goals-scroll-container">
            <div class="goal-row" v-for="(row, rowIndex) in goalRows" :key="rowIndex">
                <div class="goal-wrapper" :style="getAnimationStyle(rowIndex)">
                <div class="goal-pill" v-for="(goal, index) in repeatedGoals(row.goals)" :key="`${rowIndex}-${index}`"
                    :class="{ 'is-selected': isSelected(goal.id) }" @click="toggleGoal(goal.id)">
                    <span class="goal-emoji">{{ goal.emoji }}</span>
                    <span class="goal-text">{{ goal.text }}</span>
                    <transition name="bounce">
                    <div class="check-mark" v-if="isSelected(goal.id)">✓</div>
                    </transition>
                </div>
                </div>
            </div>
            </div>

            <div class="footer-actions">
            <button class="theme-btn secondary-btn" :disabled="selectedGoals.length === 0" @click="confirmSelection">
                开启学习计划
            </button>
            <!-- <button class="theme-btn avatar-btn" @click="openDrawer">
                <img v-if="avatarConfirmed && selectedAvatarImgUrl" :src="selectedAvatarImgUrl" class="btn-avatar-thumb">
                <span>{{ avatarConfirmed ? '更换我的形象' : '定制我的形象' }}</span>
            </button> -->
            </div>
        </div>
        </transition>

        <!-- <footer v-show="ReportData.eduRecom" class="footer-hint fade-in">
            <div class="swipe-guide">
                <span class="arrow">‹</span>
                <span>左滑查看学历提升</span>
            </div>
        </footer> -->
        <!-- <transition name="slide-up">
            <div class="drawer-overlay" v-if="drawer" @click.self="drawer = false">
                <div class="drawer-container">
                <div class="drawer-header">
                    <h2 class="drawer-title">我的 2026 形象</h2>
                    <span class="close-icon" @click="drawer = false">✕</span>
                </div>

                <div class="poster-card">
                    <div class="avatar-preview-window">
                        <transition name="fade-scale" mode="out-in">
                            <img v-if="selectedAvatarImgUrl" :src="selectedAvatarImgUrl" class="main-avatar-img" :key="selectedAvatarId">
                        </transition>
                        
                    </div>
                    <div class="avatar-selector-wrapper">
                        <p class="selector-label">选择喜欢的形象：</p>
                        <div class="avatar-grid-layout">
                            <div v-for="item in currentGenderAvatars" :key="item.id" class="grid-item" :class="{ 'active': selectedAvatarId === item.id }"  @click="selectAvatar(item.id)">
                                <img :src="item.imgUrl" alt="avatar option">
                                <div class="selected-badge" v-if="selectedAvatarId === item.id">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="drawer-footer">
                    <button class="confirm-avatar-btn" @click="confirmAvatar">
                        <span class="confirm-check">✓</span> 就选这个形象
                    </button>
                </div>
                </div>
            </div>
        </transition>

        <transition name="toast-pop">
            <div class="avatar-toast" v-if="toastVisible">
                <span class="toast-check">✓</span>
                <span>我的形象已保存</span>
            </div>
        </transition> -->
    </div>
</template>

<script>
export default {
    props: {
        ReportData: { type: Object,  required: true}
  },
    data() {
        return {
        drawer: false,
        selectedGoals: [],
        selectedAvatarId: null,
        avatarConfirmed: false,
        toastVisible: false,
        goalRows: [
            {
                goals: [
                    { id: '1', emoji: '💡', text: '技能精进 → 掌握核心岗位能力' },
                    { id: '2', emoji: '🎤', text: '过程优化 → 提升工作效率和质量' },
                    { id: '3', emoji: '🤝', text: '方法论掌握 → 系统化解决问题能力' },
                ]
            },
            {
                goals: [
                    { id: '4', emoji: '🌟', text: '行业前沿 → 跟踪最新技术与趋势' },
                    { id: '5', emoji: '🤖', text: '跨界探索 → 尝试跨部门/跨领域工作' },
                    { id: '6', emoji: '📱', text: '问题攻坚 → 提高复杂问题解决能力' }
                ]
            },
            {
                goals: [
                    { id: '7', emoji: '📅', text: '数字化能力 → 掌握数字化工具和方法' },
                    { id: '8', emoji: '📈', text: '沟通协调 → 更有效地与他人沟通' },
                    { id: '9', emoji: '🏭', text: '跨部门协作 → 学会多部门协调合作' },
                ]
            },
            {
                goals: [
                    { id: '10', emoji: '🔍', text: '影响力提升 → 增强个人在组织内的影响力' },
                    { id: '11', emoji: '🛠️', text: '变革推动 → 带动组织变革和创新' },
                    { id: '12', emoji: '🔧', text: '软实力提升 → 提升表达、谈判、沟通能力' }
                ]
            },
            {
                goals: [
                    { id: '13', emoji: '💖', text: '人际网络 → 扩展职业与社交关系' },
                    { id: '14', emoji: '🗺️', text: '心智升级 → 学会思维升级与复盘反思' },
                    { id: '15', emoji: '🧘‍♀️', text: '抗压适应 → 更好应对压力与变化' }
                ]
            },
        ],
        imgItem: [
            { id: 1, imgUrl: require('../../assets/25Year/组合A.png') },
            { id: 2, imgUrl: require('../../assets/25Year/组合B.png') },
            { id: 3, imgUrl: require('../../assets/25Year/组合C.png') },
            { id: 4, imgUrl: require('../../assets/25Year/组合D.png') },
            { id: 5, imgUrl: require('../../assets/25Year/组合E.png') },
            { id: 6, imgUrl: require('../../assets/25Year/组合F.png') },
            { id: 7, imgUrl: require('../../assets/25Year/组合G.png') }
        ],
        imgItem1: [
            { id: 'm1', imgUrl: require('../../assets/25Year/组合男1.png') },
            { id: 'm2', imgUrl: require('../../assets/25Year/组合男2.png') },
            { id: 'm3', imgUrl: require('../../assets/25Year/组合男4.png') },
            { id: 'm4', imgUrl: require('../../assets/25Year/组合男5.png') },
            { id: 'm5', imgUrl: require('../../assets/25Year/组合男6.png') },
            { id: 'm6', imgUrl: require('../../assets/25Year/组合男7.png') },
            { id: 'm7', imgUrl: require('../../assets/25Year/组合男8.png') },
            { id: 'm8', imgUrl: require('../../assets/25Year/组合男9.png') },
            // { id: 'm9', imgUrl: require('../../assets/25Year/组合男10.png') },
        ],
        };
    },
    computed: {
        currentGenderAvatars() {
            // 强制转为字符串，防止后端返回数字导致匹配失败
            const gender = String(this.ReportData.gender); 

            switch (gender) {
                case '男': // 男
                    return this.imgItem1;
                case '女': // 女
                    return this.imgItem;
                case '保密': // 保密
                    // 如果保密有专属图库就换掉，否则通常默认指向女库或通用库
                    return this.imgItem; 
                default:
                    return this.imgItem; // 默认兜底
            }
        },
        selectedAvatarImgUrl() {
            if (!this.selectedAvatarId) return null;
            const avatarObj = this.currentGenderAvatars.find(item => item.id === this.selectedAvatarId);
            return avatarObj ? avatarObj.imgUrl : '';
        }
    },
    methods: {
        selectAvatar(id) {
            this.selectedAvatarId = id;
        },
        initDefaultAvatar() {
            if (this.currentGenderAvatars.length > 0) {
                this.selectedAvatarId = this.currentGenderAvatars[0].id;
            }
        },
        openDrawer() {
            this.drawer = true;
            if (!this.selectedAvatarId) {
                this.initDefaultAvatar();
            }
        },
        confirmAvatar() {
            this.avatarConfirmed = true;
            this.drawer = false;
            this.toastVisible = true;
            clearTimeout(this._toastTimer);
            this._toastTimer = setTimeout(() => {
                this.toastVisible = false;
            }, 1800);
        },
        toggleGoal(goalId) {
        const index = this.selectedGoals.indexOf(goalId);
        if (index === -1) {
            if (this.selectedGoals.length < 3) {
            this.selectedGoals.push(goalId);
            } else {
            if (this.$message) this.$message.warning('建议聚焦 3 个核心目标哦！');
            }
        } else {
            this.selectedGoals.splice(index, 1);
        }
        },
        isSelected(goalId) {
        return this.selectedGoals.includes(goalId);
        },
        confirmSelection() {
        if (this.selectedGoals.length === 0) return;
        const selectedGoalTexts = this.selectedGoals.map(goalId => {
            for (const row of this.goalRows) {
            const foundGoal = row.goals.find(goal => goal.id === goalId);
            if (foundGoal) return foundGoal.text;
            }
            return null;
        }).filter(text => text);

        this.$emit('confirmSelection', { comment: selectedGoalTexts.join(', '), avatarId: this.selectedAvatarId });
        },
        getAnimationStyle(rowIndex) {
        const duration = 35 + rowIndex * 2;
        const direction = rowIndex % 2 === 0 ? 'normal' : 'reverse';
        return { animationDuration: `${duration}s`, animationDirection: direction };
        },
        repeatedGoals(goals) {
        // 重复 8 份，保证跑马灯内容宽度始终超过视口，宽屏下不再“靠左”、右侧空白
        const n = 8;
        const out = [];
        for (let i = 0; i < n; i++) out.push(...goals);
        return out;
        }
    },
    mounted() {
        this.initDefaultAvatar();
    }
};
</script>

<style scoped>
/* --- 年度报告风格 · 深色目标选择页 --- */
:root {
  --primary-color: #4a9eff;
  --accent-color: #4a9eff;
  --drawer-bg: #0d1430;
}

.flag-selector-container {
    position: relative;
    background:
            url("../../assets/26June/logo.png") right top no-repeat,
            url("../../assets/26October/bg.png") no-repeat center / cover;
    background-size: 100px 32px, cover;
    background-color: #1a0810;
    width: 100%;
    min-height: 100vh;
    overflow: hidden;
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.flag-selector-container * {
    text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.main-content { position: relative; z-index: 2; }

/* --- 目标选择器 --- */
.header-section {
    position: relative;
    z-index: 2;
    padding-top: 8vh;
    text-align: center;
    margin-bottom: 16px;
}

.main-title {
    font-size: 25px;
    color: #db6018;
    text-shadow: 
    -1.5px -1.5px 0 #fff,  
     1.5px -1.5px 0 #fff,
    -1.5px  1.5px 0 #fff,
     1.5px  1.5px 0 #fff;
    margin: 0;
    font-weight: 800;
    letter-spacing: 2px;
}

/* .main-title:first-child {
    background: linear-gradient(180deg, #7cc8ff, #4a9eff 60%, #2d7dd6);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.6));
    margin-bottom: 4px;
} */

.subtitle-wrapper {
    margin-top: 10px;
    display: flex;
    gap: 10px;
    justify-content: center;
}

.subtitle-badge {
    font-size: 15px;
    background: rgba(242, 214, 137, 0.4);
    border: 1px solid rgba(224, 115, 25, 0.35);
    color: #863d06;
    font-weight: 700;
    padding: 3px 12px;
    border-radius: 20px;
    letter-spacing: 1px;
}

/* 引用卡片（模板中暂未使用，保留适配） */
.quote-card {
    position: relative;
    z-index: 2;
    width: 88%;
    background: rgba(255, 245, 230, 0.15);
    border: 1px solid rgba(80, 40, 15, 0.2);
    border-left: 3px solid #379de7;
    padding: 14px 16px;
    margin-bottom: 18px;
    border-radius: 14px;
}
.sub-title { font-size: 13px; color: rgba(45,20,5,0.85); margin-top: 8px; letter-spacing: 1px; }
.goals-scroll-container { width: 100%; overflow: hidden; padding: 10px 0; }
.goal-row { display: flex; margin-bottom: 20px; height: 50px; align-items: center; }
.goal-wrapper { display: flex; width: max-content; animation: scrollGoals26Sep linear infinite; }
.goal-pill {
  background: rgba(255,245,230,0.15);
  border: 1.5px solid rgba(80,40,15,0.2);
  border-radius: 30px; padding: 9px 18px; margin: 0 10px;
  display: flex; align-items: center; gap: 4px; cursor: pointer;
  box-shadow: 0 4px 14px rgba(0,0,0,0.25), inset 0 1px 0 rgba(255,255,255,0.06);
  backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
  transition: all 0.3s; white-space: nowrap;
}
.goal-pill.is-selected {
  border-color: rgba(235, 144, 84, 0.75);
  background: rgba(239, 170, 51, 0.12);
  box-shadow: 0 6px 18px rgba(74,158,255,0.2), inset 0 1px 0 rgba(255,255,255,0.08);
}
.goal-text { font-size: 14px; color: rgba(45,20,5,0.85); font-weight: 500; }
.goal-pill.is-selected .goal-text { color: #db6018; }
.goal-emoji { font-size: 15px; }
.goal-pill .check-mark {
  width: 18px; height: 18px; border-radius: 50%;
  background: linear-gradient(135deg, #f5c4a8, #db6018);
  color: #db6018; font-size: 12px; font-weight: 900;
  display: flex; align-items: center; justify-content: center;
  margin-left: 4px;
  box-shadow: 0 0 10px rgba(223, 163, 107, 0.6);
}
.footer-actions { display: flex; flex-direction: column; align-items: center; gap: 12px; }
.theme-btn { border: none; border-radius: 50px; padding: 13px 42px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.3s; letter-spacing: 2px; }
.primary-btn {
  background: linear-gradient(180deg, #a8d8ff 0%, #4a9eff 50%, #2d7dd6 100%);
  color: #ffffff;
}
.secondary-btn {
  background: linear-gradient(180deg, #a8d8ff 0%, #4a9eff 50%, #2d7dd6 100%);
  color: #ffffff;
  box-shadow: 0 8px 24px rgba(74, 158, 255, 0.35), inset 0 1px 0 rgba(255,255,255,0.4);
}
.secondary-btn:disabled {
  background: rgba(255,255,255,0.08);
  color: rgba(45,20,5,0.3);
  box-shadow: none;
  cursor: not-allowed;
}
.secondary-btn:active:not(:disabled) { transform: scale(0.96); }
/* 次要操作：定制形象（玻璃描边按钮） */
.avatar-btn {
  padding: 11px 34px;
  font-size: 14px;
  background: rgba(74,158,255,0.08);
  color: #2d6fb8;
  border: 1.5px solid rgba(74,158,255,0.55);
  backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
}
.avatar-btn:active { transform: scale(0.96); }

/* --- 抽屉与头像选择器（暖奶油海报卡风格） --- */
.drawer-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 2000;
  background-color: rgba(45, 10, 18, 0.55); backdrop-filter: blur(8px);
  display: flex; justify-content: center; align-items: flex-end;
}

.drawer-container {
  width: 100%; max-width: 500px;
  background: linear-gradient(180deg, #fdf6ea 0%, #f6e6cf 100%);
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-bottom: none;
  border-radius: 24px 24px 0 0;
  padding: 20px 20px 16px; max-height: 90vh; display: flex; flex-direction: column;
  box-shadow: 0 -20px 60px rgba(60,20,30,0.45), inset 0 1px 0 rgba(255,255,255,0.9);
}

.drawer-header { display: flex; justify-content: space-between; margin-bottom: 12px; align-items: center; }
.drawer-title {
  font-size: 20px;
  background: linear-gradient(180deg, #5fb0ff, #2d7dd6 70%, #2368b8);
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0; font-weight: bold;
  filter: drop-shadow(0 1px 2px rgba(255,255,255,0.8));
}
.close-icon {
  font-size: 14px; color: #8a6a48; cursor: pointer;
  width: 30px; height: 30px; border-radius: 50%;
  background: rgba(138, 106, 72, 0.1);
  border: 1px solid rgba(138, 106, 72, 0.25);
  display: flex; align-items: center; justify-content: center;
  transition: all 0.25s;
}
.close-icon:active { transform: scale(0.92); background: rgba(74,158,255,0.2); color: #2d7dd6; }

.avatar-preview-window {
    position: relative;
    height: 250px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 18px;
    background:
        radial-gradient(ellipse at 50% 82%, rgba(74,158,255,0.28) 0%, rgba(74,158,255,0.08) 42%, transparent 72%),
        linear-gradient(180deg, #ffffff 0%, #f3ece1 100%);
    border: 1px solid rgba(255,255,255,0.9);
    box-shadow: inset 0 2px 8px rgba(138,106,72,0.08), 0 4px 16px rgba(138,106,72,0.12);
    overflow: hidden;
}

.avatar-selector-wrapper {
    margin-top: 16px;
    flex: 1;
    overflow-y: auto;
}

.selector-label {
    font-size: 13px;
    color: #6e4f30;
    margin: 0 0 10px 0;
    letter-spacing: 1px;
    font-weight: 600;
}

.main-avatar-img {
    position: relative;
    z-index: 1;
    max-height: 95%;
    width: auto;
    display: block;
    object-fit: contain;
    margin: 0 auto;
    filter: drop-shadow(0 8px 16px rgba(90,55,20,0.28));
}

.avatar-grid-layout {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    padding: 6px 2px 8px;
}

.grid-item {
    aspect-ratio: 1 / 1;
    border-radius: 14px;
    background: #ffffff;
    border: 1.5px solid rgba(138, 106, 72, 0.18);
    position: relative;
    transition: all 0.2s ease;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(138,106,72,0.08);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.grid-item img {
    width: 100%;
    height: 100%;
    padding: 4px;
    object-fit: contain;
    box-sizing: border-box;
}

/* 选中态 */
.grid-item.active {
    border-color: rgba(231, 133, 72, 0.9);
    background: rgba(74,158,255,0.1);
    transform: scale(1.05);
    box-shadow: 0 6px 18px rgba(74,158,255,0.3), 0 0 0 2px rgba(74,158,255,0.15);
}

/* 选中角标 */
.selected-badge {
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(135deg, #eea174, #db6018);
    width: 20px;
    height: 20px;
    border-bottom-left-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: -2px 2px 6px rgba(45,105,184,0.35);
}

.selected-badge::after {
    content: '✓';
    color: #ffffff;
    font-size: 11px;
    font-weight: 900;
}

.check-icon {
    color: #ffffff;
    font-size: 10px;
}

/* 抽屉底部确认区 */
.drawer-footer {
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.drawer-footer-hint {
  margin: 0;
  font-size: 12px;
  color: rgba(110, 79, 48, 0.75);
  letter-spacing: 0.5px;
}
.confirm-avatar-btn {
  width: 100%;
  border: none;
  border-radius: 50px;
  padding: 14px 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 2px;
  color: #ffffff;
  cursor: pointer;
  background: linear-gradient(180deg, #7cc8ff 0%, #4a9eff 50%, #2d7dd6 100%);
  box-shadow: 0 8px 22px rgba(45,125,214,0.38), inset 0 1px 0 rgba(255,255,255,0.45);
  transition: transform 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.confirm-avatar-btn:active { transform: scale(0.97); }
.confirm-check {
  width: 20px; height: 20px; border-radius: 50%;
  background: rgba(255,255,255,0.25);
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 12px;
}

/* 主页按钮内的小头像 */
.btn-avatar-thumb {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: contain;
  background: #ffffff;
  border: 1.5px solid rgba(74,158,255,0.7);
  margin-right: 4px;
  box-shadow: 0 2px 6px rgba(45,125,214,0.3);
}
.avatar-btn { display: inline-flex; align-items: center; justify-content: center; }

/* 保存成功 Toast */
.avatar-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3000;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  border-radius: 16px;
  background: rgba(38, 22, 30, 0.92);
  border: 1px solid rgba(124, 200, 255, 0.35);
  backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
  box-shadow: 0 12px 36px rgba(0,0,0,0.4), 0 0 24px rgba(74,158,255,0.2);
  white-space: nowrap;
}
.toast-check {
  width: 22px; height: 22px; border-radius: 50%;
  background: linear-gradient(135deg, #7cc8ff, #2d7dd6);
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: 900;
}
.toast-pop-enter-active, .toast-pop-leave-active { transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1); }
.toast-pop-enter, .toast-pop-leave-to { opacity: 0; transform: translate(-50%, -42%) scale(0.85); }

/* --- 底部引导 --- */
.footer-hint {
    position: relative;
    z-index: 2;
    text-align: center;
    margin-top: auto;
    padding-top: 10px;
    padding-bottom: 2vh;
}

.swipe-guide {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 15px;
    color: rgba(45,20,5,0.85);
    font-weight: 500;
    letter-spacing: 1px;
    animation: moveLeft 1.5s infinite ease-in-out;
}

.swipe-guide .arrow {
    font-size: 22px;
    color: #4a9eff;
}

/* PC 适配 */
@media screen and (min-width: 786px) {
    .flag-selector-container{
        background:
            url("../../assets/26October/pcbg.png") no-repeat center / cover;
        background-size: cover;
        /* width: 100% !important;
        height: 100vh !important; */
    }
    .avatar-grid-layout {
        grid-template-columns: repeat(4, 1fr);
    }
    /* 抽屉改为居中弹窗 */
    .drawer-overlay {
        align-items: center;
    }
    .drawer-container {
        max-width: 560px;
        max-height: 88vh;
        border-radius: 24px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.7);
    }
    .avatar-preview-window {
        height: 320px;
    }
    .drawer-header { margin-bottom: 16px; }
    .drawer-title { font-size: 24px; }
    .selector-label { font-size: 14px; }
    .avatar-grid-layout {
        gap: 14px;
    }
    .grid-item { border-radius: 16px; }
}

@media screen and (min-width: 1024px) {
    .avatar-grid-layout {
        grid-template-columns: repeat(5, 1fr);
    }
    .drawer-container {
        max-width: 640px;
    }
    .avatar-preview-window {
        height: 360px;
    }
}

/* 动画 */
@keyframes scrollGoals26Sep { 0% { transform: translateX(0); } 100% { transform: translateX(-12.5%); } }
.slide-up-enter-active, .slide-up-leave-active { transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1); }
.slide-up-enter, .slide-up-leave-to { transform: translateY(100%); }
.fade-scale-enter-active, .fade-scale-leave-active { transition: all 0.3s; }
.fade-scale-enter { opacity: 0; transform: scale(0.9); }
.fade-scale-leave-to { opacity: 0; transform: scale(1.1); }
.fade-page-enter-active { transition: opacity 0.3s; }
.fade-page-enter { opacity: 0; }
@keyframes moveLeft {
    0%, 100% { transform: translateX(0); opacity: 0.6; }
    50% { transform: translateX(-12px); opacity: 1; }
}
</style>